/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
export const BundleIconConfig = {
  name: 'BundleIcon',
  height: 1024,
  width: 1024,
  svgPath: 'M348.571 721.371l1.143-322.743 317.029-56.457 164.114 94.629 0.229 304.229-319.543 49.371zM658.514 874.743l-228.343 27.2-158.171-43.657 240.686-33.371zM1021.257 829.486v0.229l-0.686-0.229-299.886 36.571-145.143-50.286 313.6-44.343-0.457-299.2 125.486 80.229 7.086 276.343 0.457 0.229zM885.486 122.971l121.371 116.343 6.629 245.257-124.8-84.343zM349.714 318.171l-1.371-296.914 314.057-94.4 167.771 155.657 0.457 281.829-163.886-107.886zM450.971 802.514l-239.771 35.2-208.457-60.114 11.657-315.886 271.086-50.286-2.743 325.257zM25.6 117.714l259.886-80.229v293.943l-270.171 54.857z',
  yOffset: '64',
  xOffset: '',
  transform: 'rotate(180 0 512) scale(-1 1)'
};
export default createIcon(BundleIconConfig);
//# sourceMappingURL=bundle-icon.js.map